<template>
  <div style="margin: 10px">
    <el-card class="box-card" style="height: calc(100vh - 100px)">
      <el-row>
        <el-col :span="12">
          <h4>功能设置</h4>
          <el-form ref="form" :model="form" label-width="120px" :rules="rules">
            <el-form-item label="wap功能:" prop="wap">
              <el-radio-group v-model="form.wap">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="模板选择:" prop="template">
              <el-radio-group v-model="form.template">
                <el-radio :label="1">第一套</el-radio>
                <el-radio :label="2">第二套</el-radio>
                <el-radio :label="3">第三套</el-radio>
                <el-radio :label="4">第四套</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="LOGO:" prop="logo">
              <el-upload
                action=""
                list-type="picture-card"
                :limit="1"
                :show-file-list="false"
                :file-list="logoList"
                :on-exceed="handleLogo"
                :before-upload="beforePic"
              >
                <img
                  v-if="imageUrl"
                  :src="settings.apiBaseImg + imageUrl"
                  class="avatar"
                />

                <i
                  v-else
                  class="el-icon-picture-outline avatar-uploader-icon"
                ></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="主题颜色:">
              <el-color-picker v-model="form.color"></el-color-picker>
            </el-form-item>
            <el-form-item>
              <input
                type="button"
                @click="onSubmit"
                class="submit"
                value="立即提交"
              />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <!-- <el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="网站LOGO:" prop="wlogo">
							<el-upload :action="settings.apiBaseUrl+'api/v1/common/upload'" list-type="picture-card" :limit="1" :on-success="getWeb"
							 :file-list="websiteList" :on-exceed="handleLogo">
								<i class="el-icon-picture-outline"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="模板浏览:" prop="name">
						<el-upload :action="settings.apiBaseUrl+'api/v1/common/upload'" list-type="picture-card" :limit="1" :on-success="getTem"
						 :file-list="tempList" :on-exceed="handleLogo">
							<i class="el-icon-picture-outline"></i>
						</el-upload>
						</el-form-item>

					</el-form> -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        logo: '',
        template: '',
        wap: '',
        id: '',
        color: ''
      },
      rules: {
        wap: [{
          required: true,
          message: '请选择wap功能',
          trigger: 'change'
        }],
        template: [{
          required: true,
          message: '请选择w模板',
          trigger: 'change'
        }],
        logo: [{
          required: true,
          message: '请上传logo',
          trigger: 'change'
        }]
      },
      logoList: [],
      dialogImageUrl: false,
      imageUrl: ''
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/phone/get',
        params: {

        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.form.wap = res.data.data.wap
          this.form.template = parseInt(res.data.data.template)
          this.imageUrl = res.data.data.logo
          this.form.id = res.data.data.id
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    beforePic (file, fileList) {
      let objUrl = file
      let formData = new FormData()
      formData.append('file', objUrl)
      formData.append('uid', localStorage.getItem('uid'))
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/phone/upload',
        data: formData
      }).then((res) => {
        if (res.status == 200) {
          this.imageUrl = res.data.data.url
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    handleLogo (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onSubmit () {
      var obj = this
      obj.$http({
        method: 'post',
        url: 'api/v1/phone/update',
        data: {

          id: this.form.id,
          wap: this.form.wap,
          template: this.form.template,
          logo: this.imageUrl
        }
      }).then((res) => {
        if (res.data.status == 200) {
          obj.$message.success(res.data.message)
        } else {
          obj.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 140px;
  height: 140px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/phone/banner/phoneBanner.vue